import type { PropsWithChildren, ReactElement, ReactNode } from "react";

import { FlexColumn } from "@similarweb/ui-components";

import {
    StyledSignalsManagementSectionContainer,
    StyledSignalsManagementSectionFooter,
    StyledSignalsManagementSectionHeader,
    StyledSignalsManagementSectionSubTitle,
    StyledSignalsManagementSectionTitle,
} from "./styles";

interface SignalsManagementSectionProps {
    title: string;
    subTitle: ReactNode;
    actionButton?: ReactElement | null;
    footer?: ReactNode;
    "data-automation"?: string;
}

export const SignalsManagementSection = ({
    title,
    subTitle,
    actionButton,
    footer,
    children,
    "data-automation": dataAutomation = "signals-management-section",
}: PropsWithChildren<SignalsManagementSectionProps>) => {
    return (
        <StyledSignalsManagementSectionContainer data-automation={dataAutomation}>
            <StyledSignalsManagementSectionHeader>
                <FlexColumn>
                    <StyledSignalsManagementSectionTitle>{title}</StyledSignalsManagementSectionTitle>
                    <StyledSignalsManagementSectionSubTitle>{subTitle}</StyledSignalsManagementSectionSubTitle>
                </FlexColumn>
                {actionButton}
            </StyledSignalsManagementSectionHeader>
            {children}
            {footer && <StyledSignalsManagementSectionFooter>{footer}</StyledSignalsManagementSectionFooter>}
        </StyledSignalsManagementSectionContainer>
    );
};
